import React from "react";

export interface QuestionnaireOptionItem {
    id: string;
    oneAnswer?: string;
    moreAnswer?: any;
    isAnswer: boolean;
    requireFlag: BooleanValue;
}

interface QuestionnaireProps {
    questionnaire: QuestionnaireOptionItem[];
}

export const QuestionnaireContext = React.createContext<QuestionnaireProps>({
    questionnaire: []
});
